module.exports = __webpack_public_path__ + "static/euphoros-3-20ee6f2f21d4bbbdc8a29dfba12f02ec.jpg";